import { render } from "./VCalendarWrapper.vue?vue&type=template&id=f4212830&scoped=true&ts=true"
import script from "./VCalendarWrapper.vue?vue&type=script&lang=ts"
export * from "./VCalendarWrapper.vue?vue&type=script&lang=ts"

import "./VCalendarWrapper.vue?vue&type=style&index=0&id=f4212830&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4212830"]])

export default __exports__